// hooks/useProductFilter.js
import { useState, useMemo } from "react";

export const useProductFilter = (products) => {
  const [filters, setFilters] = useState({
    categories: [],
    priceMin: 0,
    priceMax: 10000,
    inStock: false,
  });
  const [sortBy, setSortBy] = useState("newest");

  // Apply filters
  const filteredProducts = useMemo(() => {
    let result = [...products];

    // Filter by categories
    if (filters.categories.length > 0) {
      result = result.filter((p) =>
        filters.categories.includes(p.category._id || p.category)
      );
    }

    // Filter by price range
    result = result.filter(
      (p) => p.price >= filters.priceMin && p.price <= filters.priceMax
    );

    // Filter by stock
    if (filters.inStock) {
      result = result.filter((p) => p.quantity > 0);
    }

    // Apply sorting
    switch (sortBy) {
      case "newest":
        result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "oldest":
        result.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        break;
      case "price-low":
        result.sort((a, b) => a.price - b.price);
        break;
      case "price-high":
        result.sort((a, b) => b.price - a.price);
        break;
      case "name-asc":
        result.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "name-desc":
        result.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "popular":
        result.sort((a, b) => (b.views || 0) - (a.views || 0));
        break;
      default:
        break;
    }

    return result;
  }, [products, filters, sortBy]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleSortChange = (newSort) => {
    setSortBy(newSort);
  };

  const handleReset = () => {
    setFilters({
      categories: [],
      priceMin: 0,
      priceMax: 10000,
      inStock: false,
    });
    setSortBy("newest");
  };

  return {
    filteredProducts,
    handleFilterChange,
    handleSortChange,
    handleReset,
  };
};
